import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommArrowLeftIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M9.07324 6.46967C8.78034 6.17678 8.30547 6.17678 8.01258 6.46967L3.71968 10.7626C3.71161 10.7706 3.70348 10.7788 3.69532 10.7869C3.55023 10.9319 3.39333 11.0887 3.27875 11.2388C3.14452 11.4148 3.00002 11.6665 3.00002 12C3.00002 12.3335 3.14452 12.5852 3.27875 12.7612C3.39333 12.9113 3.55023 13.0681 3.69532 13.2131C3.70348 13.2212 3.71161 13.2294 3.71968 13.2374L8.01258 17.5303C8.30547 17.8232 8.78034 17.8232 9.07324 17.5303C9.36613 17.2374 9.36613 16.7626 9.07324 16.4697L4.78035 12.1768C4.71029 12.1067 4.65352 12.0499 4.6052 12C4.65352 11.9501 4.71029 11.8933 4.78034 11.8232L9.07324 7.53033C9.36613 7.23744 9.36613 6.76256 9.07324 6.46967Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M3.54291 12C3.54291 12.4142 3.87869 12.75 4.29291 12.75L19.7929 12.75C20.2071 12.75 20.5429 12.4142 20.5429 12C20.5429 11.5858 20.2071 11.25 19.7929 11.25L4.29291 11.25C3.87869 11.25 3.54291 11.5858 3.54291 12Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
